// Inputer.js のスタイル
export const sectionStyle = {
  width: "100%",
  borderTop: "2px solid black",
  boxSizing: "border-box",
  padding: "10px",
  display: "flex",
  flexWrap: "wrap",
  gap:10
};

export const buttonStyle = { width: "90%" };

export const addSeriesSectionStyle = {
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  padding: "10px",
  flexWrap: "wrap",
  gap: "10px",
  textAlign: "center",
};

export const dataSeriesCardStyle = {
  borderTop: "2px solid black",
};

export const sectionCardStyle = {
  width: "100%",
  border: "1px solid #d0d7de",
  borderRadius: 12,
  background: "#fafbfc",
  boxSizing: "border-box",
  padding: "12px 14px",
  display: "flex",
  flexDirection: "column",
  gap: 10,
  marginBottom: 12,
};

export const buttonRowStyle = {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
  alignItems: "center",
};

export const fieldGroupStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
  flex: 1,
  minWidth: 140,
};

// Graph.js のスタイル
export const canvasContainerStyle = {
  position: "relative",
  width: "100%",
  height: "100%",
  marginLeft:10
};

export const canvasStyle = (height)=>{
  return({
  paddingLeft:10,
  width: "100%",
  height: `${height}%`,
  display: "block"})
};

export const xAxisLabelStyle = {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)"
};

export const yAxisContainerStyle = (axisFontSize,graphHeight)=>{
  return({
  position: "absolute",
  left: -18,
  top: 0,
  bottom: 0,
  width: 40,
  fontSize:axisFontSize,
  height:`${graphHeight}%`,

  display: "flex",
  justifyContent: "center", // 縦方向中央
  alignItems: "center",     // 横方向中央
  })
};

export const yAxisLabelStyle = {
  whiteSpace: "nowrap",
  transform: "rotate(-90deg)",
};